<p-confirmDialog key="addholiday" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="OptionsDiv">
	<label>Date:</label>
	<p-calendar [disabled]="IsLoading() == true" showIcon="true" showButtonBar="true" [(ngModel)]="EntryDate" name="EntryDate" appendTo="body"></p-calendar>

	<label>Open/Closed:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="IsOpenID" [(ngModel)]="IsOpenID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstIsOpen" [ngValue]="o.ID">{{ o.Desc }}</option>
	</select>

	<label>All Schools:</label>
	<input [disabled]="IsLoading() == true" type="checkbox" class="CHK" [(ngModel)]="AllSchools" />
</div>

<div *ngIf="AllSchools == false">
	<h4>Select School(s)</h4>

	<div>
		<caass-district-calendar-school-table [lstSchool]="lstSchool"></caass-district-calendar-school-table>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add Holiday</button>
	<button [disabled]="Processing == true" class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
